export class WorkspaceSwitchContractError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'WorkspaceSwitchContractError';
  }
}

export class WorkspaceSwitchSupersededError extends Error {
  constructor() {
    super('Workspace switch was superseded by a newer intent');
    this.name = 'WorkspaceSwitchSupersededError';
  }
}

export class WorkspaceSessionSupersededError extends Error {
  constructor(
    public readonly committedWorkspaceId?: string,
    public readonly originAuthIdentity?: string | null,
  ) {
    super('Workspace action was superseded by an auth session change');
    this.name = 'WorkspaceSessionSupersededError';
  }
}

export function isWorkspaceSessionSupersededError(
  error: unknown,
): error is WorkspaceSessionSupersededError {
  return error instanceof WorkspaceSessionSupersededError;
}

export function isWorkspaceSwitchSupersededError(
  error: unknown,
): error is WorkspaceSwitchSupersededError {
  return error instanceof WorkspaceSwitchSupersededError;
}
